import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { Component } from "react";
import { AppCard, StatusBadge } from "../../components/ui";
import { MerchantError } from "../../models/AppConstants";
import { PaymentMethods } from "../../models/FinancialData";
import { merchantPaymentMethodApiService } from "../../services/api/merchants/MerchantPaymentMethodApiService";
import { toastService } from "../../services/toastService";

interface MerchantDefaultPaymentMethodProps {
    merchantId: number | undefined;
}

interface MerchantDefaultPaymentMethodState {
    isLoading: boolean;
    merchantDefaultPaymentMethod: PaymentMethods | null;
}

export default class MerchantDefaultPaymentMethod extends Component<MerchantDefaultPaymentMethodProps, MerchantDefaultPaymentMethodState> {
    constructor(props: MerchantDefaultPaymentMethodProps) {
        super(props);

        this.state = {
            isLoading: true,
            merchantDefaultPaymentMethod: null,
        };
    }

    async componentDidMount() {
        const paymentMethodsResult = await merchantPaymentMethodApiService.getAll(this.props.merchantId!);

        if (!paymentMethodsResult.success) {
            this.setState({ isLoading: false });
            if (!paymentMethodsResult.message.includes(MerchantError.HasMissingData)) {
                toastService.error(paymentMethodsResult.message);
            }
            return;
        }

        const merchantDefaultPaymentMethod = paymentMethodsResult.data.length > 0 ? paymentMethodsResult.data[0] : null;

        this.setState({
            isLoading: false,
            merchantDefaultPaymentMethod: merchantDefaultPaymentMethod,
        });
    }

    renderMerchantDefaultPaymentMethod = () => {
        return (
            this.state.merchantDefaultPaymentMethod && (
                <AppCard>
                    <AppCard.Header title="Default Payment Method" />
                    <AppCard.Body>
                        <DataTable value={[this.state.merchantDefaultPaymentMethod]} loading={this.state.isLoading}>
                            <Column field="paymentType" header="Type"></Column>
                            <Column field="value" header="Pan / IBAN"></Column>
                            <Column field="ownerName" header="Owner Names On"></Column>
                            <Column field="lastFundsDeposited" header="Last Funds Deposited"></Column>
                            <Column field="lastFundsWithdrawn" header="Last Funds Withdrawn"></Column>
                            <Column
                                field="has2FAOr3DS"
                                header="2FA / 3DS"
                                body={(rowData: PaymentMethods) => StatusBadge(rowData.has2FAOr3DS, "Yes", "No")}
                            ></Column>
                        </DataTable>
                    </AppCard.Body>
                </AppCard>
            )
        );
    };

    render() {
        return this.renderMerchantDefaultPaymentMethod();
    }
}
